/**
 * mask text
 */

const HELLOPANDA_MASK = {
  init: function() {

    const _ = this;

    document.addEventListener('DOMContentLoaded', function() {
  
      const containers = document.querySelectorAll('.wp-block-hellopanda-masktext-block p');
      containers.forEach(container => {

        let observer;
        if (observer) {
          observer.disconnect();
        }

        const screen = container.dataset.screen === 'true' ? true : false ;
        const repeat = container.dataset.repeat === 'true' ? true : false ;

        if (screen || repeat) {
          container.setAttribute('data-style', container.getAttribute('style'));
          container.removeAttribute('style');
        }

        observer = new IntersectionObserver(
          ([entry]) => {

            if (!screen && !repeat) {
              //
            } else if (screen && !repeat) {
              if (entry.isIntersecting) {
                container.setAttribute('style', container.dataset.style);
              }
            } else if (screen && repeat) {
              if (entry.isIntersecting) {
                container.setAttribute('style', container.dataset.style);
              } else {
                container.removeAttribute('style');
              }
            }

          },
          { 
            root: document,
            threshold: [0, 1],
            rootMargin: `0px 0px 0px 0px`,
            /* required options*/
            trackVisibility: true,
            delay: 100 // minimum 100
          }
        );

        const slide = container.closest('.swiper-slide');
        if (slide && screen) {

          // 팝업창이 있는지 체크한다.
          const popup = container.closest('.wp-block-hellopanda-popup-block');
          if (popup) {

            // 팝업이 있으면 준비된 후에 실행
            if (popup.getAttribute('status') === 'ready') {
              _.slider_compatible(container, repeat, slide);
            } else {
              const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                  if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'status' &&
                    popup.getAttribute('status') === 'ready'
                  ) {
                    observer.disconnect(); // 한 번 감지 후 정리
                    _.slider_compatible(container, repeat, slide, popup);
                  }
                }
              });

              observer.observe(popup, {
                attributes: true,
                attributeFilter: ['status'],
              });
            }

          // 팝업이 없으면 일반 슬라이더 옵저버를 실행
          } else {
            _.slider_compatible(container, repeat, slide, popup);
          }

        } else {

          // 일반 옵저버 수행
          observer.observe(container);

        }

        // 준비 되었음
        container.classList.add('is-ready');

      });
      
    });
  },

  slider_compatible: function(container, repeat, slide, popup) {

    const _ = this;

    let timeoutId;

    const slideWrapper = slide.closest('.swiper-wrapper');

    // 슬라이더 내부 옵저버 수행
    const observer_slide = new MutationObserver(() => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      const isActive = slide.classList.contains('swiper-slide-active');
      if (isActive) {
        if (!container.classList.contains('slider-inside-mask-init')) {
          container.removeAttribute('style');
          container.setAttribute('style', container.dataset.style);
          container.classList.add('slider-inside-mask-init');
        } else {
          if (repeat) {
            container.removeAttribute('style');
            container.setAttribute('style', container.dataset.style);
          } else {
            container.dataset.style = container.getAttribute('style');
            container.style.removeProperty('animation-delay');
            container.style.removeProperty('animation-duration');
            container.style.removeProperty('animation-timing-function');
          }
        }
      } else {
        if (repeat) {
          let durationMs = 0;
          const durationRaw = slideWrapper ? getComputedStyle(slideWrapper).transitionDuration || '' : '' ;
          const durationPart = durationRaw.split(',')[0].trim() || '' ;
          const durationValue = durationPart ? parseFloat(durationPart) : 0 ;
          const isSeconds = durationPart.includes('s') && !durationPart.includes('ms');
          if (!isNaN(durationValue)) {
            durationMs = isSeconds ? durationValue * 1000 : durationValue ;
          }
          timeoutId = setTimeout(() => {
            container.removeAttribute('style');
          }, Math.max(0, durationMs));
        }
      }
    });
    observer_slide.observe(slide, {
      attributes: true,
      attributeFilter: ['class'],
    });

    /**
     * 팝업에 영향을 받는다면, 
     * 팝업이 준비 되었을 때 트리거를 실행
     */
    if (popup) {
      let popupTimerId;
      if (popupTimerId) {
        clearTimeout(popupTimerId);
      }
      const durationSec = _.getPopupDuration(popup); // 예: 0.5 (초)
      const delayMs = (durationSec * 1000) + 500;
      popupTimerId = setTimeout(() => {
        if (!slide.classList.contains('popup-inside-mask-init')) {
          slide.classList.add('popup-inside-mask-init');
        }
        popupTimerId = null; // 타이머 초기화
      }, delayMs);
    }

  },

  // 지연 시간을 가져온다.
  getPopupDuration: function(el) {
    if (!el) return 0;

    const duration = window.getComputedStyle(el).animationDuration;
    const toSeconds = (value) => {
      if (value.endsWith('ms')) return parseFloat(value) / 1000;
      if (value.endsWith('s')) return parseFloat(value);
      const num = parseFloat(value);
      return isNaN(num) ? 0 : num;
    };

    const durations = duration.split(',').map(d => toSeconds(d.trim()));
    return durations[0] || 0;
  }
};
HELLOPANDA_MASK.init();